import { Spinner } from '@dashboard/ui'

export const DrawerSpinner = () => {
  return (
    <div className="flex size-full items-center justify-center">
      <Spinner className="text-text-quarterary" size={24} />
    </div>
  )
}
